import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function InteractiveFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'What types of businesses qualify for funding?',
    a: 'Most businesses qualify if they have been operating for at least 6 months and have monthly revenue of $10,000 or more. We work with all industries including high-risk sectors.'
  }, {
    q: 'How fast can I get approved?',
    a: 'Our streamlined process allows for approvals in as little as 24 hours, with funding often available the next business day.'
  }, {
    q: 'What documents do I need to apply?',
    a: 'To start, we typically only need a simple application and your last 3 months of business bank statements.'
  }, {
    q: 'Will applying hurt my credit score?',
    a: 'No. We perform a soft credit pull for the initial application, which does not impact your credit score.'
  }, {
    q: 'What if I have bad credit?',
    a: 'We specialize in helping business owners with all credit profiles. Revenue and time in business are often more important than personal credit score.'
  }, {
    q: 'Are there any upfront fees?',
    a: 'No. There are absolutely no upfront fees to apply or receive a quote. We only get paid when you get funded.'
  }, {
    q: 'What can I use the funding for?',
    a: 'You can use the funds for any business purpose: working capital, equipment, inventory, marketing, expansion, payroll, or debt consolidation.'
  }];
  return <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black" data-id="element-391">
      <div className="max-w-3xl mx-auto" data-id="element-392">
        <div className="text-center mb-12" data-id="element-393">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-394">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-zinc-400" data-id="element-395">
            Common questions about our funding process
          </p>
        </div>

        <div className="space-y-4" data-id="element-396">
          {faqs.map((faq, index) => <div key={index} className="bg-zinc-900/50 rounded-xl border border-zinc-800 overflow-hidden backdrop-blur-sm hover:bg-zinc-900 transition-colors" data-id="element-397">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center" data-id="element-398">
                <span className="font-bold text-white text-lg" data-id="element-399">{faq.q}</span>
                {openIndex === index ? <MinusIcon className="w-5 h-5 text-white" data-id="element-400" /> : <PlusIcon className="w-5 h-5 text-zinc-500" data-id="element-401" />}
              </button>
              <AnimatePresence data-id="element-402">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-403">
                    <div className="px-6 pb-6 text-zinc-400 leading-relaxed border-t border-zinc-800 pt-4" data-id="element-404">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}